<script setup lang="ts">
import type { IProps } from '~/components/entity/card'
import type { ICardTypes } from '~/components/widget/select-card-type'
import type { IResponseData } from '~/types'
const props = defineProps<IProps>()
const url = computed(() => useUrlWithParams('/card_types', { ...props.queryParams }))
const { data } = useApi<IResponseData<ICardTypes[]>>(() => url, {
  key: 'card-types-sidebar-widget'
})
const route = useRoute()

const cardsTypes = computed(() => {
  return data.value?.data.map((i) => {
    const itemUrl = route.name.includes('bank-cards')
      ? `/cards/${i.slug}?q=${route.params.bank}`
      : `/cards/${i.slug}`
    return {
      title: i.title,
      url: itemUrl,
      icon: i.slug
    }
  })
})
</script>

<template>
  <SidebarBlock
    v-if="cardsTypes"
    :heading-text="$t('widget.select_card_type.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="cardsTypes" />
  </SidebarBlock>
</template>
